export const apartmentsImport = (context) => (id, commit) => ({
    type: "APARTMENTS.IMPORT",
    payload: { id, commit },
    context,
});
